import React, { useEffect, useState } from "react";
import styles from './challengeBar.module.css' 
import Trending from './trending'
import {Link} from 'react-router-dom'
import Ongoing from "./ongoing";
import Upcoming from "./upcoming";
import Previous from "./previous";

const ChallengeBar =()=>{

const [coption,setCoption]=useState("ongoing")
const [mode,setMode]=useState('challange')

const highlight={
    color:"#7124BD"
}


const  botombar ={
    borderBottom:"solid 2px #7124BD"
}




    return(
        <div className={styles.challengeCon}>
                <div className={styles.cardCon}>
                     <div className={styles.header}>
                <div style={mode==="challange"?botombar:{}} onClick={()=>setMode("challange")} className={styles.modeName}>Challanges</div>
                <div style={mode==="trending"?botombar:{}} onClick={()=>setMode("trending")} className={styles.modeName}>Trending</div>
            </div>
        {mode==="trending"?<Trending/>:<>
            <div className={styles.ctypecon}>
                <div style={coption==="previous"?highlight:{}} onClick={()=>setCoption("previous")}>Previous</div>
                <div style={coption==="ongoing"?highlight:{}} onClick={()=>setCoption("ongoing")}>ongoing</div>
                <div style={coption==="upcomeing"?highlight:{}} onClick={()=>setCoption("upcomeing")}>upcoming</div>
               

            </div>
            
            <div className={styles.challenges}>

         {coption==="ongoing"?<Ongoing/>:""}
         {coption==="upcomeing"?<Upcoming/>:""}
         {coption==="previous"?<Previous/>:""}
             
                      </div>
                      </>}
                      </div>
                      

        </div>
    )
}

export default ChallengeBar;